export default "__VITE_ASSET__CF$LdnSe__"